export default __webpack_public_path__ + "static/media/Px GCSF PDF DEC 2017.f853447e.pdf";